import { render } from "./FutPayment.vue?vue&type=template&id=326d18f0"
import script from "./FutPayment.vue?vue&type=script&lang=js"
export * from "./FutPayment.vue?vue&type=script&lang=js"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__